<template>
    <v-container fluid class="incidente-root">
        <div>
            <h2>Mapa</h2>
            
            <div class="mapa-layout">
                <!-- MAPA -->
                <div class="mapa-wrap" :class="{ 'mapa-wrap--con-panel': panelVisible }">
                    <div id="mapa" class="mapa-box"></div>
                </div>
                <!-- PANEL DERECHO -->
                <transition name="slide-panel">
                    <div v-if="panelVisible" class="panel-depto">
                        <div class="panel-depto__header">
                            <div class="panel-depto__title-wrap">
                                <v-icon color="#f7c325" class="mr-2">mdi-home-city</v-icon>
                                <h3 class="panel-depto__title">{{ deptoSeleccionado }}</h3>
                            </div>

                            <v-btn icon class="panel-close-btn" @click="cerrarPanel">
                                <v-icon color="#384018">mdi-close</v-icon>
                            </v-btn>
                        </div>

                        <v-divider class="panel-divider"></v-divider>
                        <div class="panel-section-title d-flex align-center justify-space-between">
                            <!-- IZQUIERDA -->
                            <div class="d-flex align-center">
                                <v-icon color="#f7c325" class="mr-2">mdi-account-group</v-icon>
                                <span class="title-text">RESUMEN</span>
                            </div>
                            <!-- DERECHA (BOTÓN VER MÁS) -->
                            <v-btn small style="background-color: #f7c325;" @click="dialogdetail = true">
                                <v-icon left small>mdi-eye</v-icon>
                                Ver más
                            </v-btn>
                        </div>

                        <div class="panel-cards-grid">
                            <v-row dense class="dialog-filter-row">
                                <v-col cols="12" md="6">
                                    <div class="panel-info-card">
                                        <div class="panel-info-card__label">Funcionarios</div>
                                        <div class="panel-info-card__value">{{ totalFuncionarios }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="panel-info-card">
                                        <div class="panel-info-card__label">Unidades</div>
                                        <div class="panel-info-card__value">{{ unidadStats.length }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="panel-info-card">
                                        <div class="panel-info-card__label">Cargos</div>
                                        <div class="panel-info-card__value">{{ cargoStats.length }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="panel-info-card">
                                        <div class="panel-info-card__label">Destinos</div>
                                        <div class="panel-info-card__value">{{ destinoStats.length }}</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>

                        <div class="panel-section-title">
                            <v-icon color="#f7c325" class="mr-2">mdi-chart-bar</v-icon>
                            DISTRIBUCIÓN POR CIUDAD
                        </div>
                        <div class="panel-list">
                            <div v-for="(item, index) in topCiudades" :key="index" class="panel-list-item">
                                <span>{{ item.nombre }}</span>
                                <span class="panel-badge">{{ item.total }}</span>
                            </div>
                        </div>
                        <div class="panel-section-title">
                            <v-icon color="#f7c325" class="mr-2">mdi-account-group</v-icon>
                            ESTADO CIVIL
                        </div>
                        <div class="panel-list">
                            <div v-for="(item, index) in estadoCivilStats" :key="index" class="panel-list-item">
                                <span>{{ item.nombre }}</span>
                                <span class="panel-badge">{{ item.total }}</span>
                            </div>
                        </div>
                        <div class="panel-section-title">
                            <v-icon color="#f7c325" class="mr-2">mdi-gender-male-female</v-icon>
                            GÉNERO
                        </div>
                        <div class="panel-list">
                            <div v-for="(item, index) in generoStats" :key="'gen-' + index" class="panel-list-item">
                                <span>{{ item.nombre }}</span>
                                <span class="panel-badge">{{ item.total }}</span>
                            </div>
                        </div>
                        <div class="panel-section-title">
                            <v-icon color="#f7c325" class="mr-2">mdi-calendar-account</v-icon>
                            RANGOS DE EDAD
                        </div>
                        <div class="panel-list">
                            <div v-for="(item, index) in edadStats" :key="'edad-' + index" class="panel-list-item">
                                <span>{{ item.nombre }}</span>
                                <span class="panel-badge">{{ item.total }}</span>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            
        </div>

        <v-dialog v-model="dialogdetail" max-width="90%" scrollable content-class="dialog-detalle-mapa">
            <v-card class="dialog-detalle-card">
                <!-- HEADER -->
                <v-card-title class="dialog-detalle-header d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                        <v-icon color="#f7c325" class="mr-2">mdi-home-city</v-icon>
                        <span class="dialog-detalle-title">
                            Detalle de {{ deptoSeleccionado }}
                        </span>
                    </div>

                    <v-btn icon @click="dialogdetail = false">
                        <v-icon color="#384018">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider class="dialog-detalle-divider"></v-divider>

                <v-card-text class="dialog-detalle-body">
                    <!-- RESUMEN SUPERIOR -->
                    <div class="dialog-section-title">
                        <v-icon color="#f7c325" class="mr-2">mdi-chart-box</v-icon>
                        RESUMEN GENERAL
                    </div>
                    <div class="dialog-resumen-grid">
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Funcionarios</div>
                            <div class="dialog-info-card__value">{{ totalFuncionarios }}</div>
                        </div>
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Ciudades</div>
                            <div class="dialog-info-card__value">{{ topCiudades.length }}</div>
                        </div>
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Unidades</div>
                            <div class="dialog-info-card__value">{{ unidadStats.length }}</div>
                        </div>
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Cargos</div>
                            <div class="dialog-info-card__value">{{ cargoStats.length }}</div>
                        </div>
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Destinos</div>
                            <div class="dialog-info-card__value">{{ destinoStats.length }}</div>
                        </div>
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Grados</div>
                            <div class="dialog-info-card__value">{{ gradoStats.length }}</div>
                        </div>
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Estados civiles</div>
                            <div class="dialog-info-card__value">{{ estadoCivilStats.length }}</div>
                        </div>
                        <div class="dialog-info-card">
                            <div class="dialog-info-card__label">Géneros</div>
                            <div class="dialog-info-card__value">{{ generoStats.length }}</div>
                        </div>
                    </div>
                    <!-- TABS -->
                    <v-tabs v-model="tabDetalleMapa" background-color="transparent" color="#f7c325" dark grow class="dialog-tabs">
                        <v-tab>
                            <v-icon left small>mdi-chart-bar</v-icon> Resumen General
                        </v-tab>
                        <v-tab>
                            <v-icon left small>mdi-briefcase-account</v-icon> Resumen Estrategico
                        </v-tab>
                        <v-tab>
                            <v-icon left small>mdi-account-details</v-icon> Funcionarios
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabDetalleMapa" class="dialog-tabs-items">
                        <!-- TAB 1: RESUMEN -->
                        <v-tab-item>
                            <div class="dialog-columns mt-4">
                                <div class="dialog-column">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-map-marker-radius</v-icon>
                                        DISTRIBUCIÓN POR CIUDAD
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in topCiudades" :key="'detalle-ciudad-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-account-heart</v-icon> ESTADO CIVIL
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in estadoCivilStats" :key="'detalle-estado-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="dialog-column">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-gender-male-female</v-icon> GÉNERO
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in generoStats" :key="'detalle-genero-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-calendar-account</v-icon> RANGOS DE EDAD
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in edadStats" :key="'detalle-edad-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-tab-item>
                        <!-- TAB 2: LABORAL -->
                        <v-tab-item>
                            <v-row class="mt-4">
                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">
                                            mdi-account-star
                                        </v-icon>
                                        CATEGORÍA CAS
                                    </div>

                                    <div class="dialog-list">
                                        <div
                                            v-for="(item, index) in categoriaStats"
                                            :key="'cas-' + index"
                                            class="dialog-list-item"
                                        >
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">
                                            mdi-map-marker-radius
                                        </v-icon>
                                        FRONTERA
                                    </div>

                                    <div class="dialog-list">
                                        <div
                                            v-for="(item, index) in fronteraStats"
                                            :key="'frontera-' + index"
                                            class="dialog-list-item"
                                        >
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">
                                            mdi-shield-account
                                        </v-icon>
                                        FUNCIÓN POLICIAL
                                    </div>

                                    <div class="dialog-list">
                                        <div
                                            v-for="(item, index) in funcionesStats"
                                            :key="'funcion-' + index"
                                            class="dialog-list-item"
                                        >
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>

                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">
                                            mdi-police-badge-outline
                                        </v-icon>
                                        GRADO POLICIAL
                                    </div>

                                    <div class="dialog-list">
                                        <div
                                            v-for="(item, index) in gradoPolicialStats"
                                            :key="'gpol-' + index"
                                            class="dialog-list-item"
                                        >
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-police-badge</v-icon> GRADOS
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in gradoStats" :key="'grado-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-office-building</v-icon> TOP UNIDADES
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in unidadStats" :key="'unidad-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-briefcase</v-icon> TOP CARGOS
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in cargoStats" :key="'cargo-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <div class="dialog-section-title">
                                        <v-icon color="#f7c325" class="mr-2">mdi-map-marker-account</v-icon> TOP DESTINOS
                                    </div>
                                    <div class="dialog-list">
                                        <div v-for="(item, index) in destinoStats" :key="'destino-' + index" class="dialog-list-item">
                                            <span>{{ item.nombre }}</span>
                                            <span class="dialog-badge">{{ item.total }}</span>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <!-- TAB 3: FUNCIONARIOS -->
                        <v-tab-item>
                            <div class="dialog-section-title mt-4">
                                <v-icon color="#f7c325" class="mr-2">mdi-filter</v-icon>
                                FILTROS
                            </div>
                            <v-row dense class="dialog-filter-row">
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="filtroDetalle.search" label="Buscar funcionario" dense outlined clearable prepend-inner-icon="mdi-magnify" />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.oid_grado" :items="Lgrado" item-value="oid" item-text="nombre" label="Grado" dense outlined clearable multiple />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.oid_unidad" :items="Lunidad" item-value="oid" item-text="nombre" label="Unidad" dense outlined clearable multiple />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.oid_cargo" :items="Lcargo" item-value="oid" item-text="nombre" label="Cargo" dense outlined clearable multiple />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.oid_destino" :items="Ldestino" item-value="oid" item-text="nombre" label="Destino" dense outlined clearable multiple />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.oid_categoria" :items="Lcas" item-text="nombre" item-value="oid" label="Categoria CAS" outlined dense multiple clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.oid_frontera" :items="Lfrontera" item-text="nombre" item-value="oid" label="Frontera" outlined dense multiple clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.oid_funciones" :items="Lfunciones" item-text="nombre" item-value="oid" label="Función Policial" outlined dense multiple clearable />
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-autocomplete v-model="filtroDetalle.grado_policial" :items="Lgpolicial" item-text="nombre" item-value="oid" label="Grado Policial" outlined dense multiple clearable />
                                </v-col>
                            </v-row>
                            <div class="dialog-section-title mt-2 d-flex justify-space-between align-center">
                                <div>
                                    <v-icon color="#f7c325" class="mr-2">mdi-account-details</v-icon>
                                    DETALLE DE FUNCIONARIOS ({{ funcionariosDeptoFiltrados.length }})
                                </div>
                                <div>
                                    <v-btn small class="perfil-btn mr-2" style="background-color: #e4b510;" @click="limpiarFiltrosDetalle">
                                        <v-icon left small>mdi-filter-remove</v-icon> Limpiar filtros
                                    </v-btn>
                                    <v-btn
                                        small class="perfil-btn" style="background-color: #e4b510;" @click="exportarFuncionariosDepto">
                                        <v-icon left small>mdi-microsoft-excel</v-icon> Exportar
                                    </v-btn>
                                </div>
                            </div>
                            <div class="dialog-table-wrap">
                                <table class="dialog-table">
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Ciudad</th>
                                            <th>Grado</th>
                                            <th>Cargo</th>
                                            <th>Unidad</th>
                                            <th>Destino</th>
                                            <th>Estado civil</th>
                                            <th>Género</th>
                                            <th>Edad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(persona, index) in funcionariosDeptoFiltrados" :key="'persona-' + index">
                                            <td>
                                                {{ persona.nombres }} {{ persona.primero_apellido }} {{ persona.segundo_apellido }}
                                            </td>
                                            <td>{{ getCiudadN(persona.oid_ciudad) || 'Sin ciudad' }}</td>
                                            <td>{{ getGradoN(persona.oid_grado) }}</td>
                                            <td>{{ getCargoN(persona.oid_cargo) }}</td>
                                            <td>{{ getUnidadN(persona.oid_unidad) }}</td>
                                            <td>{{ getDestinoN(persona.oid_destino) }}</td>
                                            <td>{{ getEstadoCivilNombre(persona.oid_estado_civil) }}</td>
                                            <td>{{ getGeneroNombre(persona.oid_genero) }}</td>
                                            <td>{{ calcularEdad(persona.fecha_nacimiento) || '—' }}</td>
                                        </tr>
                                        <tr v-if="!funcionariosDeptoFiltrados || funcionariosDeptoFiltrados.length === 0">
                                            <td colspan="9" class="text-center">
                                                No hay funcionarios que coincidan con los filtros.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>

import axios from 'axios';
import { setRols, getRolN, getAreaN, setAreas } from '@/utils/validators';
import {
  loadAll, getOptionsByCodigo,
  setDatos, getPaises, getDeptos, getCiudades,
  getPaisN, getDeptoN, getCiudadN,
  getNameById
} from '@/utils/catalogo';
import { utils, writeFileXLSX } from 'xlsx';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

export default {
    data() {
        return {
            datos: [],
            LPais: [], LDepto: [], LCiudad: [],
            dato: {
                oid: 0,
                password_hash: 'aa',
                nombres: '',
                primero_apellido: '',
                segundo_apellido: '',
                oid_tipo_documento: null,
                documento: '',
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_depto_nacimiento: null,
                oid_ciudad_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                telefono: '',
                oid_user: null,
                verificado: null,
                activo: null,
                lat: null,
                lng: null
            },
            Catalogo: {
                EstadoCivil: [],
                TipoDocumento: [],
                Nacionalidad: [],
                Genero: [],
            },
            map: null,
            geojsonLayer: null,
            panelVisible: false,
            deptoSeleccionado: '',
            totalFuncionarios: 0,
            topCiudades: [],
            estadoCivilStats: [], nacionalidadStats: [], generoStats: [], edadStats: [],
            dialogdetail: false,
            unidadStats: [], cargoStats: [], destinoStats: [], gradoStats: [],categoriaStats: [], fronteraStats: [], funcionesStats: [], gradoPolicialStats: [],
            tabDetalleMapa: 0,
            filtroDetalle: {
                search: '',
                oid_grado: [],
                oid_cargo: [],
                oid_unidad: [],
                oid_destino: [],
                oid_categoria: [],
                oid_frontera: [],
                oid_funciones: [],
                grado_policial: [],
            },
            Lgrado: [], Lcargo: [], Lunidad: [],
            Ldestino: [], Lcas: [], Lfunciones: [], Lgpolicial: [], Lfrontera: [],
        }
    },
    async mounted() {
        await this.cargarCatalogos();
        await this.cargarCatalogosLaborales();

        await setDatos();
        this.LPais   = getPaises();
        this.LDepto  = getDeptos();
        this.LCiudad = getCiudades();

        await this.listar();
        await this.initMap();
    },
    computed: {
        catMap() {
            const toMap = arr => (arr || []).reduce((m, it) => { m[it.oid] = it.nombre; return m; }, {});
            return {
                TipoDocumento: toMap(this.Catalogo.TipoDocumento),
                Nacionalidad:  toMap(this.Catalogo.Nacionalidad),
                Genero:        toMap(this.Catalogo.Genero),
                EstadoCivil:   toMap(this.Catalogo.EstadoCivil),
            };
        },
        funcionariosDeptoDetalle() {
            if (!this.deptoSeleccionado) return []

            return this.obtenerFuncionariosPorDepto(this.deptoSeleccionado)
                .slice()
                .sort((a, b) => {
                    const nombreA = `${a.nombres || ''} ${a.primero_apellido || ''} ${a.segundo_apellido || ''}`.trim().toLowerCase()
                    const nombreB = `${b.nombres || ''} ${b.primero_apellido || ''} ${b.segundo_apellido || ''}`.trim().toLowerCase()
                    return nombreA.localeCompare(nombreB)
                })
        },
        funcionariosDeptoFiltrados() {
            let lista = this.funcionariosDeptoDetalle || [];

            const search = (this.filtroDetalle.search || '').toLowerCase().trim();

            if (search) {
                lista = lista.filter(p => {
                    const texto = `
                        ${p.nombres || ''}
                        ${p.primero_apellido || ''}
                        ${p.segundo_apellido || ''}
                        ${p.documento || ''}
                        ${p.correo || ''}
                    `.toLowerCase();

                    return texto.includes(search);
                });
            }

            const grados = this.filtroDetalle.oid_grado || [];
            const unidades = this.filtroDetalle.oid_unidad || [];
            const cargos = this.filtroDetalle.oid_cargo || [];
            const destinos = this.filtroDetalle.oid_destino || [];
            const funciones = this.filtroDetalle.oid_funciones || [];
            const frontera = this.filtroDetalle.oid_frontera || [];
            const gpolicial = this.filtroDetalle.grado_policial || [];
            const categorias = this.filtroDetalle.oid_categoria || [];

            if (grados.length > 0) {
                lista = lista.filter(p => grados.map(Number).includes(Number(p.oid_grado)));
            }
            if (unidades.length > 0) {
                lista = lista.filter(p => unidades.map(Number).includes(Number(p.oid_unidad)));
            }
            if (cargos.length > 0) {
                lista = lista.filter(p => cargos.map(Number).includes(Number(p.oid_cargo)));
            }
            if (destinos.length > 0) {
                lista = lista.filter(p => destinos.map(Number).includes(Number(p.oid_destino)));
            }
            if (funciones.length > 0) {
                lista = lista.filter(p => funciones.map(Number).includes(Number(p.oid_funciones)));
            }
            if (frontera.length > 0) {
                lista = lista.filter(p => frontera.map(Number).includes(Number(p.oid_frontera)));
            }
            if (gpolicial.length > 0) {
                lista = lista.filter(p => gpolicial.map(Number).includes(Number(p.grado_policial)));
            }
            if (categorias.length > 0) {
                lista = lista.filter(p => categorias.map(Number).includes(Number(p.oid_categoria)));
            }

            return lista;
        }
    },
    methods: {
        async initMap() {
            this.map = L.map('mapa').setView([-16.6478, -64.4834], 6)

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap'
            }).addTo(this.map)

            await this.loadBoliviaGeoJson()
        },
        async loadBoliviaGeoJson() {
            try {
                const response = await fetch('/bolivia.geojson')
                const geojson = await response.json()

                this.geojsonLayer = L.geoJSON(geojson, {
                    style: {
                        color: '#1976D2',
                        weight: 2,
                        opacity: 1,
                        fillColor: '#42A5F5',
                        fillOpacity: 0.2
                    },
                    onEachFeature: (feature, layer) => {
                        const nombreDepto = this.obtenerNombreDeptoGeojson(feature)

                        layer.on('click', () => {
                                const stats = this.calcularResumenDepto(nombreDepto)

                                this.deptoSeleccionado = nombreDepto || 'Departamento'
                                this.totalFuncionarios = stats.total
                                this.topCiudades = stats.topCiudades
                                this.estadoCivilStats = stats.estadoCivilStats
                                this.nacionalidadStats = stats.nacionalidadStats
                                this.generoStats = stats.generoStats
                                this.edadStats = stats.edadStats
                                this.gradoStats = stats.gradoStats
                                this.cargoStats = stats.cargoStats
                                this.unidadStats = stats.unidadStats
                                this.destinoStats = stats.destinoStats
                                this.categoriaStats = stats.categoriaStats
                                this.fronteraStats = stats.fronteraStats
                                this.funcionesStats = stats.funcionesStats
                                this.gradoPolicialStats = stats.gradoPolicialStats
                                this.panelVisible = true

                                // Ajustar mapa
                                setTimeout(() => {
                                    this.map.invalidateSize()
                                }, 300)
                            })

                        layer.on('mouseover', () => {
                            layer.setStyle({
                                weight: 3,
                                fillOpacity: 0.35
                            })
                        })

                        layer.on('mouseout', () => {
                            this.geojsonLayer.resetStyle(layer)
                        })
                    }
                }).addTo(this.map)

                this.map.fitBounds(this.geojsonLayer.getBounds())
            } catch (error) {
                console.error('Error cargando el GeoJSON de Bolivia:', error)
            }
        },
        async cargarCatalogos() {
            await loadAll();

            this.Catalogo.TipoDocumento   = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.Genero        = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil        = getOptionsByCodigo('EstadoCivil');
        },
        async cargarCatalogosLaborales() {
            const [g, c, u, d, cc, fb, f, gp] = await Promise.all([
                axios.get('api/Grados/Listar'),
                axios.get('api/Cargos/Listar'),
                axios.get('api/Unidads/Listar'),
                axios.get('api/Destinos/Listar'),
                axios.get('api/Categoria_cas/Listar'),
                axios.get('api/FonteraBonos/Listar'),
                axios.get('api/Funciones/Listar'),
                axios.get('api/GradoPolicials/Listar')
            ]);

            this.Lgrado = g.data || [];
            this.Lcargo = c.data || [];
            this.Lunidad = u.data || [];
            this.Ldestino = d.data || [];
            this.Lcas = cc.data || [];
            this.Lfunciones = f.data || [];
            this.Lgpolicial = gp.data || [];
            this.Lfrontera = fb.data || [];
        },
        // Obtener la lista
        async listar() {
            try {
                const pageSize = 1000;
                let page = 1;
                let total = 0;
                let todos = [];

                do {
                    const response = await axios.get('api/PersonaInfoGenerals/ListarCompleto', {
                        params: {
                            page,
                            pageSize
                        }
                    });

                    const data = response.data.data || [];

                    todos = todos.concat(data);
                    total = response.data.total || 0;

                    page++;
                } while (todos.length < total);

                this.datos = todos;
            } catch (error) {
                console.error(error);
            }
        },
        normalizarTexto(texto) {
            return (texto || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .trim()
        },
        obtenerNombreDeptoGeojson(feature) {
            const p = feature.properties || {}

            return (
                p.name ||
                p.NAME ||
                p.depto ||
                p.departamento ||
                p.nom_dep ||
                p.NOM_DEP ||
                p.DPTO ||
                ''
            )
        },
        obtenerFuncionariosPorDepto(nombreDepto) {
            const nombreNormalizado = this.normalizarTexto(nombreDepto)

            return this.datos.filter(f => {
                const nombreFuncionarioDepto = getDeptoN(f.oid_depto) || ''
                return this.normalizarTexto(nombreFuncionarioDepto) === nombreNormalizado
            })
        },
        cerrarPanel() {
            this.panelVisible = false

            setTimeout(() => {
                this.map.invalidateSize()
            }, 300)
        },
        calcularResumenDepto(nombreDepto) {
            const datosDepto = this.obtenerFuncionariosPorDepto(nombreDepto)

            const total = datosDepto.length

            const topCiudades = this.agruparPor(
                datosDepto,
                f => getCiudadN(f.oid_ciudad) || 'Sin ciudad'
            ).slice(0, 5)

            const estadoCivilStats = this.agruparPor(
                datosDepto,
                f => this.getEstadoCivilNombre(f.oid_estado_civil)
            )

            const nacionalidadStats = this.agruparPor(
                datosDepto,
                f => this.getNacionalidadNombre(f.oid_nacionalidad_actual)
            ).slice(0, 5)

            const generoStats = this.agruparPor(
                datosDepto,
                f => this.getGeneroNombre(f.oid_genero)
            )

            const edadStats = this.agruparPor(
                datosDepto,
                f => {
                    const edad = this.calcularEdad(f.fecha_nacimiento)
                    return this.obtenerRangoEdad(edad)
                }
            )

            const gradoStats = this.agruparPor(
                datosDepto,
                f => this.getGradoN(f.oid_grado)
            );

            const cargoStats = this.agruparPor(
                datosDepto,
                f => this.getCargoN(f.oid_cargo)
            ).slice(0, 10);

            const unidadStats = this.agruparPor(
                datosDepto,
                f => this.getUnidadN(f.oid_unidad)
            ).slice(0, 10);

            const destinoStats = this.agruparPor(
                datosDepto,
                f => this.getDestinoN(f.oid_destino)
            ).slice(0, 10);

            const categoriaStats = this.agruparPor(
                datosDepto,
                f => this.getCategoriaN(f.oid_categoria)
            );

            const fronteraStats = this.agruparPor(
                datosDepto,
                f => this.getFronteraN(f.oid_frontera)
            );

            const funcionesStats = this.agruparPor(
                datosDepto,
                f => this.getFuncionesN(f.oid_funciones)
            );

            const gradoPolicialStats = this.agruparPor(
                datosDepto,
                f => this.getGradoPolicialN(f.grado_policial)
            );

            return {
                total,
                topCiudades,
                estadoCivilStats,
                nacionalidadStats,
                generoStats,
                edadStats,
                gradoStats,
                cargoStats,
                unidadStats,
                destinoStats,
                categoriaStats,
                fronteraStats,
                funcionesStats,
                gradoPolicialStats
            }
        },
        getEstadoCivilNombre(oid) {
            return getNameById(oid) || 'Sin dato'
        },
        getGeneroNombre(oid) {
            return getNameById(oid) || 'Sin dato'
        },
        getNacionalidadNombre(oid) {
            return getNameById(oid) || 'Sin dato'
        },
        agruparPor(lista, obtenerClave) {
            const agrupado = {}

            lista.forEach(item => {
                const clave = obtenerClave(item) || 'Sin dato'
                agrupado[clave] = (agrupado[clave] || 0) + 1
            })

            return Object.entries(agrupado)
                .map(([nombre, total]) => ({ nombre, total }))
                .sort((a, b) => b.total - a.total)
        },
        calcularEdad(fechaNacimiento) {
            if (!fechaNacimiento) return null

            const fecha = new Date(fechaNacimiento)
            if (isNaN(fecha.getTime())) return null

            const hoy = new Date()
            let edad = hoy.getFullYear() - fecha.getFullYear()
            const mes = hoy.getMonth() - fecha.getMonth()

            if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) {
                edad--
            }

            return edad
        },
        obtenerRangoEdad(edad) {
            if (edad == null || edad < 0) return 'Sin dato'
            if (edad <= 25) return '18 - 25'
            if (edad <= 35) return '26 - 35'
            if (edad <= 45) return '36 - 45'
            if (edad <= 55) return '46 - 55'
            return '56+'
        },
        limpiarFiltrosDetalle() {
            this.filtroDetalle = {
                search: '',
                oid_grado: [],
                oid_cargo: [],
                oid_unidad: [],
                oid_destino: []
            };
        },
        getCiudadN,
        getGradoN(id) {
            const item = (this.Lgrado || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getCargoN(id) {
            const item = (this.Lcargo || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getUnidadN(id) {
            const item = (this.Lunidad || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getDestinoN(id) {
            const item = (this.Ldestino || []).find(x => Number(x.oid) === Number(id));
            return item ? (item.nombre || 'Sin dato') : 'Sin dato';
        },
        getCategoriaN(id) {
            const item = (this.Lcas || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },
        getFronteraN(id) {
            const item = (this.Lfrontera || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },
        getFuncionesN(id) {
            const item = (this.Lfunciones || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },
        getGradoPolicialN(id) {
            const item = (this.Lgpolicial || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : 'Sin dato';
        },
        exportarFuncionariosDepto() {
            const lista = this.funcionariosDeptoFiltrados || [];

            if (lista.length === 0) {
                return;
            }

            const rows = lista.map(persona => ({
                "Documento": persona.documento || "",
                "Nombre completo": [
                    persona.nombres,
                    persona.primero_apellido,
                    persona.segundo_apellido
                ].filter(Boolean).join(" "),
                "Correo": persona.correo || "",
                "Teléfono": persona.telefono || "",
                "Departamento": this.deptoSeleccionado || "",
                "Ciudad": getCiudadN(persona.oid_ciudad) || "Sin ciudad",
                "Grado": this.getGradoN(persona.oid_grado),
                "Cargo": this.getCargoN(persona.oid_cargo),
                "Unidad": this.getUnidadN(persona.oid_unidad),
                "Destino": this.getDestinoN(persona.oid_destino),
                "Estado civil": this.getEstadoCivilNombre(persona.oid_estado_civil),
                "Género": this.getGeneroNombre(persona.oid_genero),
                "Fecha nacimiento": persona.fecha_nacimiento
                    ? persona.fecha_nacimiento.substring(0, 10)
                    : "",
                "Edad": this.calcularEdad(persona.fecha_nacimiento) || "",
                "Categoría CAS": this.getCategoriaN(persona.oid_categoria),
                "Frontera": this.getFronteraN(persona.oid_frontera),
                "Función policial": this.getFuncionesN(persona.oid_funciones),
                "Grado policial": this.getGradoPolicialN(persona.grado_policial),
            }));

            const hoja = utils.json_to_sheet(rows);

            hoja["!cols"] = [
                { wch: 16 },
                { wch: 36 },
                { wch: 30 },
                { wch: 16 },
                { wch: 18 },
                { wch: 22 },
                { wch: 24 },
                { wch: 28 },
                { wch: 28 },
                { wch: 28 },
                { wch: 18 },
                { wch: 16 },
                { wch: 18 },
                { wch: 10 },
                { wch: 22 },
                { wch: 22 },
                { wch: 26 },
                { wch: 24 },
            ];

            const libro = utils.book_new();
            utils.book_append_sheet(libro, hoja, "Funcionarios");

            const fecha = new Date().toISOString().substring(0, 10);
            const nombreDepto = (this.deptoSeleccionado || "Departamento")
                .replace(/\s+/g, "_")
                .replace(/[^\w]/g, "");

            writeFileXLSX(libro, `Funcionarios_${nombreDepto}_${fecha}.xlsx`);
        },
    }
}
</script>
<style scoped>
.mapa-root {
    background: transparent;
}

.mapa-titulo {
    color: #4a5123;
    font-size: 28px;
    font-weight: 800;
    margin-bottom: 14px;
}

.mapa-layout {
    display: flex;
    gap: 14px;
    align-items: stretch;
}

.mapa-wrap {
    width: 100%;
    transition: width 0.32s ease;
}

.mapa-wrap--con-panel {
    width: 70%;
}

.mapa-box {
    height: 750px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.10);
}

.panel-depto {
    width: 30%;
    min-width: 320px;
    height: 750px;
    max-height: 750px;
    border-radius: 18px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fbfcfa;
    box-shadow: 0 14px 36px rgba(59, 71, 33, 0.14);
    border: 1px solid rgba(108, 117, 51, 0.16);
    display: flex;
    flex-direction: column;
}

.panel-depto__header {
    position: sticky;
    top: 0;
    z-index: 5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 18px 12px 18px;
    background: linear-gradient(180deg, #eef0ea 0%, #e2e6d8 100%);
    border-bottom: 1px solid rgba(108, 117, 51, 0.15);
}

.panel-depto__title {
    margin: 0;
    color: #384018;
    font-size: 20px;
    font-weight: 800;
}

.panel-depto__title-wrap {
    display: flex;
    align-items: center;
}

.panel-close-btn {
    margin-top: -2px;
}

.panel-divider {
    position: sticky;
    top: 62px;
    z-index: 4;
    border-color: rgba(247, 195, 37, 0.22) !important;
    background: transparent;
}

.panel-section-title {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #5e672c;
    font-size: 18px;
    font-weight: 800;
    padding: 18px 18px 10px 18px;
    text-align: center;
}

.panel-cards-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 14px;
    padding: 6px 14px 14px 14px;
}

.panel-info-card {
    background: linear-gradient(180deg, #f8f9f6 0%, #eef0eb 100%);
    border: 1px solid rgba(108, 117, 51, 0.12);
    border-left: 4px solid #c9a538;
    border-radius: 14px;
    padding: 8px 14px;
}

.panel-info-card__label {
    color: #727b4a;
    font-weight: 800;
    font-size: 12px;
    text-transform: uppercase;
}

.panel-info-card__value {
    color: #303641;
    font-weight: 800;
    font-size: 28px;
}

/* Animación panel */
.slide-panel-enter-active,
.slide-panel-leave-active {
    transition: all 0.30s ease;
}

.slide-panel-enter,
.slide-panel-leave-to {
    opacity: 0;
    transform: translateX(18px);
}

/* Responsive */
@media (max-width: 1100px) {
    .mapa-layout {
        flex-direction: column;
    }

    .mapa-wrap,
    .mapa-wrap--con-panel,
    .panel-depto {
        width: 100%;
    }

    .panel-depto {
        min-width: 100%;
    }
}


.panel-list {
    padding: 10px 14px;
}

.panel-list-item {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid rgba(108, 117, 51, 0.12);
    color: #303641;
    font-weight: 700;
}

.panel-badge {
    background: #3a3f4a;
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid rgba(247,195,37,0.3);
    color: #f7c325;
    font-weight: 800;
}
.panel-depto::-webkit-scrollbar {
    width: 8px;
}

.panel-depto::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.06);
    border-radius: 10px;
}

.panel-depto::-webkit-scrollbar-thumb {
    background: rgba(247, 195, 37, 0.55);
    border-radius: 10px;
}

.panel-depto::-webkit-scrollbar-thumb:hover {
    background: rgba(247, 195, 37, 0.8);
}

.mapa-wrap,
.mapa-box,
#mapa {
    position: relative;
    z-index: 1;
}

::v-deep .v-overlay {
    z-index: 2999 !important;
}

::v-deep .v-dialog__content {
    z-index: 3000 !important;
}

/* DIALOG DETALLE CLARO */
.dialog-detalle-card {
    border-radius: 20px !important;
    overflow: hidden;
    background: #fbfcfa !important;
    color: #303641;
    border: 1px solid rgba(108, 117, 51, 0.14);
    box-shadow: 0 14px 36px rgba(59, 71, 33, 0.16);
}

.dialog-detalle-header {
    background: linear-gradient(180deg, #eef0ea 0%, #e2e6d8 100%);
    padding: 18px 22px;
    border-bottom: 1px solid rgba(108, 117, 51, 0.15);
}

.dialog-detalle-title {
    color: #384018;
    font-size: 22px;
    font-weight: 800;
}

.dialog-detalle-divider {
    border-color: rgba(108, 117, 51, 0.15) !important;
}

.dialog-detalle-body {
    padding: 20px !important;
    max-height: 75vh;
    overflow-y: auto;
    background: #fbfcfa;
}

.dialog-section-title {
    display: flex;
    align-items: center;
    color: #5e672c;
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 12px;
    margin-top: 10px;
    text-transform: uppercase;
}

.dialog-resumen-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-bottom: 22px;
}

.dialog-info-card {
    background: linear-gradient(180deg, #f8f9f6 0%, #eef0eb 100%);
    border: 1px solid rgba(108, 117, 51, 0.12);
    border-left: 4px solid #c9a538;
    border-radius: 14px;
    padding: 10px 14px;
}

.dialog-info-card__label {
    color: #727b4a;
    font-weight: 800;
    font-size: 12px;
    text-transform: uppercase;
}

.dialog-info-card__value {
    color: #303641;
    font-weight: 800;
    font-size: 28px;
}

.dialog-columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.dialog-column {
    min-width: 0;
}

.dialog-list {
    background: #ffffff;
    border: 1px solid rgba(108, 117, 51, 0.12);
    border-radius: 14px;
    padding: 10px 14px;
    margin-bottom: 18px;
}

.dialog-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid rgba(108, 117, 51, 0.10);
    color: #303641;
    font-weight: 700;
}

.dialog-list-item:last-child {
    border-bottom: none;
}

.dialog-badge {
    background: #3a3f4a;
    padding: 4px 10px;
    border-radius: 8px;
    border: 1px solid rgba(247,195,37,0.3);
    color: #f7c325;
    font-weight: 800;
    min-width: 34px;
    text-align: center;
}

.dialog-table-wrap {
    overflow-x: auto;
    border-radius: 14px;
    background: #ffffff;
    border: 1px solid rgba(108, 117, 51, 0.12);
    padding: 10px;
}

.dialog-table {
    width: 100%;
    border-collapse: collapse;
    color: #303641;
}

.dialog-table th {
    text-align: left;
    color: #5e672c;
    font-weight: 800;
    padding: 12px 10px;
    border-bottom: 1px solid rgba(108,117,51,0.18);
    background: rgba(201, 165, 56, 0.10);
}

.dialog-table td {
    padding: 12px 10px;
    border-bottom: 1px solid rgba(108,117,51,0.08);
    color: #303641;
    font-weight: 600;
}

.dialog-table tbody tr:hover {
    background: rgba(108, 117, 51, 0.04);
}


.dialog-tabs {
    border-bottom: 1px solid rgba(108, 117, 51, 0.18);
    margin-top: 10px;
}

.dialog-tabs-items {
    background: transparent !important;
}

::v-deep .dialog-tabs .v-tab {
    color: #5e672c !important;
    font-weight: 800;
}

::v-deep .dialog-tabs .v-tab--active {
    color: #384018 !important;
}

::v-deep .dialog-tabs .v-tabs-slider {
    background-color: #c9a538 !important;
}

@media (max-width: 960px) {
    .dialog-resumen-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .dialog-columns {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 600px) {
    .dialog-resumen-grid {
        grid-template-columns: 1fr;
    }
}
::v-deep .dialog-filter-row .v-input__slot {
    background: #ffffff !important;
}

::v-deep .dialog-filter-row label,
::v-deep .dialog-filter-row input {
    color: #303641 !important;
}
</style>